import lazyLoading from './lazyLoading'

export default {
  name: 'Home IoT Dashboard',
  path: '/homeiotdashboard',
  redirect: '/homeiotdashboard/dashboard',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homeiotdashboard', true),
  children: [
    {
      'name': 'Dashboard for MKT team',
      'path': 'dashboardMKT',
      'meta': {
        'label': 'MKT Team Dashboard'
      },
      'component': lazyLoading('homeiotdashboard/dashboardMKT')
    },
    {
      'name': 'Dashboard for CE Team',
      'path': 'dashboardCE',
      'meta': {
        'label': 'CE Team Dashboard'
      },
      'component': lazyLoading('homeiotdashboard/dashboardCE')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/homeiotdashboard.js